import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-linea-temporal',
  templateUrl: './linea-temporal.component.html',
  styleUrls: ['./linea-temporal.component.css']
})
export class LineaTemporalComponent implements OnInit {

  ngOnInit(): void {
  }

}
